import debounce from '../util/debounce';

const selectors = {
  disclosureToggle: 'data-hover-disclosure-toggle',
  disclosureWrappper: '[data-hover-disclosure]',
  link: '[data-top-link]',
  meganavVisible: 'meganav--visible',
  wrapper: '[data-header-wrapper]',
  stagger: '[data-stagger]',
  staggerPair: '[data-stagger-first]',
  staggerAfter: '[data-stagger-second]',
  staggerImage: '[data-grid-item], [data-header-image]',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
};

const classes = {
  isVisible: 'is-visible',
};

let sections = {};
let disclosures = {};

class HoverDisclosure {
  constructor(el) {
    this.disclosure = el;
    this.wrapper = el.closest(selectors.wrapper);
    this.key = this.disclosure.id;
    const btnSelector = `[${selectors.disclosureToggle}='${this.key}']`;
    this.trigger = document.querySelector(btnSelector);
    this.link = this.trigger.querySelector(selectors.link);
    this.grandparent = this.trigger.classList.contains('grandparent');

    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);

    this.connectHoverToggle();
    this.handleTablets();
    this.staggerChildAnimations();
  }

  onBlockSelect(evt) {
    if (this.disclosure.contains(evt.target)) {
      this.showDisclosure();
    }
  }

  onBlockDeselect(evt) {
    if (this.disclosure.contains(evt.target)) {
      this.hideDisclosure();
    }
  }

  showDisclosure() {
    if (this.grandparent) {
      this.wrapper.classList.add(selectors.meganavVisible);
    } else {
      this.wrapper.classList.remove(selectors.meganavVisible);
    }
    this.trigger.setAttribute('aria-expanded', true);
    this.trigger.classList.add(classes.isVisible);
    this.disclosure.classList.add(classes.isVisible);
  }

  hideDisclosure() {
    this.disclosure.classList.remove(classes.isVisible);
    this.trigger.classList.remove(classes.isVisible);
    this.trigger.setAttribute('aria-expanded', false);
    this.wrapper.classList.remove(selectors.meganavVisible);
  }

  staggerChildAnimations() {
    const simple = this.disclosure.querySelectorAll(selectors.stagger);
    simple.forEach((el, index) => {
      el.style.transitionDelay = `${index * 50 + 10}ms`;
    });

    const pairs = this.disclosure.querySelectorAll(selectors.staggerPair);
    pairs.forEach((child, i) => {
      const d1 = i * 150;
      child.style.transitionDelay = `${d1}ms`;
      child.parentElement.querySelectorAll(selectors.staggerAfter).forEach((grandchild, i2) => {
        const di1 = i2 + 1;
        const d2 = di1 * 20;
        grandchild.style.transitionDelay = `${d1 + d2}ms`;
      });
    });

    const images = this.disclosure.querySelectorAll(selectors.staggerImage);
    images.forEach((el, index) => {
      el.style.transitionDelay = `${(index + 1) * 80}ms`;
    });
  }

  handleTablets() {
    // first click opens the popup, second click opens the link
    this.trigger.addEventListener(
      'touchstart',
      function (e) {
        const isOpen = this.disclosure.classList.contains(classes.isVisible);
        if (!isOpen) {
          e.preventDefault();
          this.showDisclosure();
        }
      }.bind(this),
      {passive: true}
    );
  }

  connectHoverToggle() {
    this.trigger.addEventListener('mouseenter', debounce(this.showDisclosure.bind(this), 100));
    this.link.addEventListener('focus', debounce(this.showDisclosure.bind(this), 100));

    this.trigger.addEventListener('mouseleave', debounce(this.hideDisclosure.bind(this), 100));
    this.trigger.addEventListener(
      'focusout',
      debounce(
        function (e) {
          const inMenu = this.trigger.contains(e.relatedTarget);
          if (!inMenu) {
            this.hideDisclosure();
          }
        }.bind(this)
      ),
      100
    );
    this.disclosure.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hideDisclosure();
      }.bind(this)
    );
  }
}

const hoverDisclosure = {
  onLoad() {
    sections[this.id] = [];
    disclosures = this.container.querySelectorAll(selectors.disclosureWrappper);
    disclosures.forEach((el) => {
      sections[this.id].push(new HoverDisclosure(el));
    });
  },
  onBlockSelect(evt) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockSelect(evt);
      }
    });
  },
  onBlockDeselect(evt) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockDeselect === 'function') {
        el.onBlockDeselect(evt);
      }
    });
  },
};

export default hoverDisclosure;
